import axiosInstance from "../axios";
import { baseURLGame, AUTH, REQUEST } from "../../utils/endPoints";
import { getQueryParamFromUrl } from "../../helpers/url";
import { loginAction } from "./slice";
import { authType } from "../../types/login";
import { GameStep, LoginSteps, ModalStep } from "../../types/config";
import { configAction } from "../config/slice";
import { checkTaraWallet } from "../wallet/action";
import { walletAction } from "../wallet/slice";
export const getPhone = function (phone: string, type: string) {
  return async (dispatch: Function) => {
    dispatch(loginAction.setRequestLoading(true));

    try {
      const config = {
        url: `${baseURLGame}${REQUEST}`,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          phone: phone,
          type: type,
        },
      };
      const response = await axiosInstance(config);
      dispatch(loginAction.setRequestData(response.data));
      if (response.status === 200) {
        dispatch(configAction.setLoginStep(LoginSteps.OTP));
      } else {
        dispatch(
          loginAction.setRequestError(
            response.data.data
              ? response.data.data.message
              : "مشکلی پیش امده لطفا مجدد تلاش کنید"
          )
        );
      }
    } catch (error) {
      dispatch(
        loginAction.setRequestError("مشکلی پیش امده لطفا مجدد تلاش کنید")
      );
      console.log(error);
    }
  };
};

export const getOTP = function (phone: string, token: string) {
  const objUrlParams = getQueryParamFromUrl();
  let data: any = { phone: phone, token: token };
  for (let key in objUrlParams) {
    if (key === "id") {
      data.invite_id = objUrlParams[key];
    }
    if (objUrlParams[key] === "harmony") {
      data.provider = objUrlParams[key];
      data.clickId = `${objUrlParams[key]}_utm_source`;
    }
  }
  return async (dispatch: Function) => {
    dispatch(walletAction.setTaraWalletLoading(true));
    dispatch(loginAction.setAuthLoading(true));

    try {
      const config = {
        url: `${baseURLGame}${AUTH}`,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
      };
      const response = await axiosInstance(config);
      const authData = response.data as authType;
      if (authData.status === "success") {
        dispatch(loginAction.setAuthData(authData));
        dispatch(configAction.setToken(authData.data.token));
        // setTimeout(() => {
        //   dispatch(checkTaraWallet(authData.data.token));
        // }, 2500);
        dispatch(loginAction.setUserData(authData.data.user.user));
        localStorage.setItem(
          "banimodeUserProd",
          JSON.stringify(authData.data.user)
        );
        dispatch(configAction.setGameStep(GameStep.HOME));
        dispatch(configAction.setModalStep(ModalStep.DEFAULT));
        return authData;
      } else {
        dispatch(loginAction.setAuthError(authData.message));
      }
    } catch (error) {
      console.log(error);
    }
  };
};
